import { call, put, takeEvery, delay } from 'redux-saga/effects';

import { actionTypes, MIN_SEC_BEFORE_TOKEN_EXPIRATION, MAX_SEC_BEFORE_TOKEN_EXPIRATION } from './constants';
import { NotificationSettingsApi } from 'api';
import { notify } from 'sharedComponents/GeneralNotification';
import { NOTIFICATION_TYPES } from '../../../SharedComponents/GeneralNotification/constants';
import authHelper from 'helpers/authHelper';

function* getNotificationListSaga() {
    const maxRetries = 10;
    let retryCount = 0;

    while (retryCount < maxRetries) {
        const authTokens = authHelper.getAccessTokenData();
        const currentDate = Math.floor(Date.now() / 1000);
        const SecondsUntilExpiration = authTokens?.expires_at - currentDate;

        if (SecondsUntilExpiration >= MIN_SEC_BEFORE_TOKEN_EXPIRATION && SecondsUntilExpiration <= MAX_SEC_BEFORE_TOKEN_EXPIRATION || retryCount >= 9) {
            try {
                const response = yield call(NotificationSettingsApi.getNotificationList);
                if (response?.messages) {
                    yield put({ type: actionTypes.SET_NOTIFICATION_LIST, payload: response?.messages });
                }
            } catch (error) {
                yield put({ type: actionTypes.SET_NOTIFICATION_LIST, payload: [] });
                notify(error.message, NOTIFICATION_TYPES.ERROR, true);
            }
            return;
        }

        retryCount++;

        if (retryCount < maxRetries) {
            yield delay(10000);
        }
    }
}

function* readNotificationListSaga({ groupId }) {
    try {
        yield call(NotificationSettingsApi.readNotification, groupId);
    } catch (error) {
        notify(error.message, NOTIFICATION_TYPES.ERROR, true);
    }
}

export function* notificationPanelWatchers() {
    yield takeEvery(actionTypes.GET_NOTIFICATION_LIST, getNotificationListSaga);
    yield takeEvery(actionTypes.READ_NOTIFICATION, readNotificationListSaga);
}
